<template>
	<div class="layout">
		<Split v-model="split">
			<div slot="left" class="demo-split-pane">
				<div class="layout-title">
					<div class="layout-title-left">
						商品导航树
					</div>
					<div class="layout-title-right">
						<Button type="dashed" title="添加商品种类" @click="openCommodityTypeModal" style="margin-right:10px;"
							v-show="permission.isAddCommodityType">
							<Icon type="md-add-circle" size='18' />
						</Button>
						<Button type="dashed" title="删除商品种类" @click="deleteCommodityType"
							v-show="permission.isDeleteCommodityType">
							<Icon type="md-trash" size='18' />
						</Button>
					</div>
				</div>

				<Tree :data="treeData" ref="commodityTree" style="margin: 20px 10px;" @on-select-change="clickNode">
				</Tree>
			</div>
			<div slot="right" class="demo-split-pane">
				<div class="layout-title">
					<div class="layout-title-left">
						<img src="/static/imgs/shangpin.png" class="jxyd-imgicon" />
						商品列表
					</div>
					<div class="layout-title-right">
						<Dropdown>
							<a href="javascript:void(0)" class="jxyd-a">
								下载模板
								<Icon type="ios-arrow-down"></Icon>
							</a>
							<DropdownMenu slot="list">
								<DropdownItem>
									<a href="/static/商品导入模板.xlsx" class="jxyd-a" style="font-size:13px;">商品导入模板</a>
								</DropdownItem>
							</DropdownMenu>
						</Dropdown>
						<button class="jxyd-button" title="新建商品" @click="addCommodity" style="margin-left:10px;"
							v-show="permission.isAdd">
							<Icon type="md-add-circle" size='18' /> 新建
						</button>
						<a href="javascript:void(0)" style="margin-left:10px;" @click="handleDownLoad"
							class="jxyd-button" v-show="permission.isExport">
							<Icon type="md-open" size='18' /> 导出
						</a>
						<Dropdown @on-click="batchFunc" style="margin-left:10px;">
							<a href="javascript:void(0)" class="jxyd-a">
								批量操作
								<Icon type="ios-arrow-down"></Icon>
							</a>
							<DropdownMenu slot="list">
								<Upload action="/api/Util/UploadExcel" style="display:inline-block;"
									:show-upload-list="false" :max-size="2048" :format="['xlsx','xls']"
									:on-format-error="batchAddCommodityFormatError"
									:on-exceeded-size="uploadFileSizeError" :before-upload="batchAddCommodityBefore"
									:on-success="batchAddCommoditySuccess" :on-error="batchAddCommodityError"
									v-show="permission.isBatchImport">
									<DropdownItem class="dropdown-item">
										<Icon type="md-exit" size='18' />
										<span>批量导入</span>
									</DropdownItem>
								</Upload>
								<DropdownItem name='batchDele' v-show="permission.isDelete" class="dropdown-item">
									<Icon type="md-trash" size='18' />
									<span>删除</span>
								</DropdownItem>
								<DropdownItem name="createCode" v-show="permission.isCreateCode" class="dropdown-item">
									<Icon type="ios-barcode-outline" size='18' />
									<span>打印条码</span>
								</DropdownItem>
								<DropdownItem name="printSKUCode" v-show="permission.isCreateCode"
									class="dropdown-item">
									<Icon type="ios-barcode-outline" size='18' />
									<span>打印单品</span>
								</DropdownItem>
							</DropdownMenu>
						</Dropdown>
					</div>
				</div>
				<div id="layout-box">
					<div id="box-search">
						<Form ref="formSearch" :label-width="70" :model="searchItems" inline>
							<Row :gutter="16">
								<Col :lg="6" :md="24">
								<FormItem label="商品名" style="width:100%">
									<Input type="text" v-model="searchItems.name" placeholder="商品名"
										@keyup.enter.native="initListData(1)" />
								</FormItem>
								</Col>
								<Col :lg="6" :md="24">
								<FormItem label="商品条码" style="width:100%">
									<Input type="text" v-model="searchItems.code" placeholder="使用扫码抢或手动输入"
										@keyup.enter.native="initListData(1)" icon="md-qr-scanner" />
								</FormItem>
								</Col>
								<Col :lg="6" :md="24">
								<FormItem label="规格" style="width:100%">
									<Input type="text" v-model="searchItems.format" placeholder="规格"
										@keyup.enter.native="initListData(1)" />
								</FormItem>
								</Col>
								<Col :lg="6" :md="24">
								<FormItem label="是否启用" style="width:100%">
									<Select v-model="searchItems.isUse" @on-change="initListData(1)">
										<Option :value="-1" :key="-1">请选择</Option>
										<Option :value="0" :key="0">否</Option>
										<Option :value="1" :key="1">是</Option>
									</Select>
								</FormItem>
								</Col>
							</Row>
							<Row :gutter="16" v-show="advancedSelect">
								<Col :lg="6" :md="24">
								<FormItem label="仓库" style="width:100%">
									<Select filterable clearable v-model="searchItems.depotId"
										@keyup.enter.native="initListData(1)">
										<Option :value="0" :key="0">请选择</Option>
										<Option v-for="item in depotList" :value="item.id" :key="item.id">
											{{ item.depotName }}
										</Option>
									</Select>
								</FormItem>
								</Col>
								<Col :lg="6" :md="24">
								<FormItem label="备注" style="width:100%">
									<Input type="text" v-model="searchItems.note" placeholder="备注"
										@keyup.enter.native="initListData(1)" />
								</FormItem>
								</Col>
							</Row>
							<FormItem :label-width="20">
								<button class="jxyd-button jxyd-primary" @click="initListData(1)"
									style="margin-right:10px;">查询</button>
								<button class="jxyd-button jxyd-borderbtn" @click="initSearch"
									style="margin-right:10px;">重置</button>
								<span @click="advancedSelect = true;" style="color:red;cursor: pointer;"
									v-if="!advancedSelect">
									展开
									<Icon type="ios-arrow-down" size='18' />
								</span>
								<span @click="foldSearch" style="color:red;cursor: pointer;" v-else>
									折叠
									<Icon type="ios-arrow-up" size='18' />
								</span>
							</FormItem>
						</Form>
					</div>
					<div id="box-table">
						<Table row-key="guid" ref="commodity" :columns="commodityColumn" :data="commodityData"
							@on-selection-change="listCheckedChange"></Table>
					</div>
					<div id="page-box">
						<Page show-sizer :total="commodityCount" :page-size="searchItems.pageSize"
							@on-change="pageChange" show-total show-elevator :page-size-opts='pageSizeOpts'
							:current="searchItems.pageIndex" @on-page-size-change='pageSizeChange'>
						</Page>
					</div>
				</div>
			</div>
		</Split>
		<Modal v-model="commodityTypeModal" draggable sticky scrollable :styles="{top: '100px'}">
			<p slot="header" class="modal-header">
				<img src="/static/imgs/shangpin.png" class="jxyd-imgicon" />
				<span>操作商品种类</span>
			</p>

			<Form ref="commodityTypeform" :model="commodityTypeFormItem" :label-width="70"
				:rules="commodityTypeRuleRole">
				<div style="background-color:#fff;padding:20px;border-radius:5px;">
					<Form-item label="名称" prop="key">
						<Input v-model="commodityTypeFormItem.key" placeholder="请输入" size="large" />
					</Form-item>
				</div>
			</Form>

			<div slot="footer">
				<Button @click="commodityTypeModal = false">取消</Button>
				<Button type="primary" @click="commodityTypeSubmit(1)">保存</Button>
				<Button type="success" @click="commodityTypeSubmit(2)">保存并继续</Button>
			</div>
		</Modal>

		<!-- 使用封装的图片预览子组件 -->
		<ImagePreview ref="imagePreview" :images="previewImagesList" :visible.sync="previewVisible"
			:initial-index="currentImageIndex" @change="onPreviewImageChange" />

		<!-- 使用封装的自定义抽屉组件 -->
		<CustomDrawer v-model="viewCommodityStock" :title="`库存信息`" :width="700" placement="right" :mask="true"
			:mask-closable="true" :closable="true">
			<template #title>
				<div class="drawer-title">
					<div class="drawer-title-left">
						<Icon type="ios-search" :size='18' />
						库存信息
					</div>
					<div class="drawer-title-right content-left-right-split">
						<Input placeholder="输入规格或仓库或批次" v-model="stockModalSearchVal"
							@keyup.enter.native="initStockData(commodityCurrentIndex)" />
						<button class="jxyd-button jxyd-primary" type="primary"
							@click="initStockData(commodityCurrentIndex)">确定</button>
					</div>
				</div>
			</template>
			<div class="drawer-content">
				<Table :height='tableHeight' disabled-hover :columns="stockColumn" :data="stockData">
				</Table>
			</div>
			<template #footer>
				<button class="jxyd-button jxyd-primary" type="primary" @click="viewCommodityStock = false">确定</button>
			</template>
		</CustomDrawer>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import ImagePreview from '@/components/ImagePreview' // 导入图片预览子组件
	import CustomDrawer from '@/components/CustomDrawer' // 导入自定义抽屉组件

	export default {
		name: 'commoditymanage',
		components: {
			CustomDrawer,
			ImagePreview
		},
		data() {
			return {
				split: 0.2,
				searchItems: {
					name: '',
					code: '',
					format: '',
					isUse: -1,
					depotId: 0,
					note: '',
					type: [],
					sort: '',
					pageSize: 10,
					pageIndex: 1
				},
				selectedItem: [],
				selectedId: [],
				commodityCount: 0,
				commodityData: [],
				commodityColumn: [{
						type: 'selection',
						width: 60,
						align: 'center',
						fixed: 'left'
					},
					{
						title: '商品图片',
						key: 'imgs',
						width: 100,
						render: (h, params) => {
							return [h('div', {
								style: {
									'width': '40px',
									'height': '40px',
									'cursor': 'pointer'
								},
								on: {
									click: (val) => {
										this.previewSkuImages(params.row.imgFile);
									}
								}
							}, [h('Avatar', {
								style: {
									'width': '100%',
									'height': '100%',
								},
								attrs: {
									'src': params.row.imgFile.length > 0 ? params.row.imgFile[
											0]
										.url :
										'/file/file/GetFile?fileName=DefaultCommodity.png&path=/app/Uploads/FIXIMG/DefaultCommodity.png',
								}
							})])];
						}
					},
					{
						title: '商品',
						key: 'name',
						width: 200,
						render: (h, params) => {
							return h('a', {
								class: 'jxyd-a',
								on: {
									click: (e) => {
										this.$router.push({
											path: 'commoditydetailinfo',
											query: {
												commodityId: params.row.id
											}
										});
									}
								}
							}, params.row.name)
						}
					},
					{
						title: '单位',
						key: 'unit',
						width: 150
					},
					{
						title: '规格',
						key: 'format',
						width: 200
					},
					{
						title: '种类',
						key: 'type',
						width: 200
					},
					{
						title: '采购价',
						key: 'intoPrice',
						width: 150,
						render: (h, params) => {
							return h('span', {}, params.row.intoPrice + '元');
						}
					},
					{
						title: '零售价',
						key: 'retailPrice',
						width: 150,
						render: (h, params) => {
							return h('span', {}, params.row.retailPrice + '元');
						}
					},
					{
						title: '批发价',
						key: 'wholesalePricePrice',
						width: 150,
						render: (h, params) => {
							return h('span', {}, params.row.wholesalePricePrice + '元');
						}
					},
					{
						title: '当前库存',
						key: 'stock',
						width: 150
					},
					{
						title: '备注',
						key: 'note',
						width: 300,
					},
					{
						title: '操作',
						key: 'action',
						width: 150,
						align: 'center',
						fixed: 'right',
						render: (h, params) => {
							var btnArr = [];
							if (this.permission.isEdit) {
								btnArr.push(h('a', {
									class: ['jxyd-a'],
									style: {
										'margin-right': '5px'
									},
									attrs: {},
									on: {
										click: (e) => {
											this.editCommodity(params.row);
										}
									},
								}, "编辑"));
								btnArr.push(h('a', {
									class: ['jxyd-a'],
									style: {
										'margin-right': '5px'
									},
									attrs: {},
									on: {
										click: (e) => {
											this.commodityCurrentIndex = params.row.id;
											this.initStockData(params.row.id);
											this.viewCommodityStock = true;
										}
									},
								}, "库存信息"));
							}
							return btnArr;
						}
					}
				],
				treeData: [],
				depotList: [],
				commodityTypePid: 'spzl',
				commodityTypeModal: false,
				commodityTypeFormItem: {
					id: 0,
					key: '',
					value: '',
					note: '',
					pid: 0,
					pcode: '',
					creator: parseInt(localStorage.getItem("userId"))
				},
				commodityTypeRuleRole: {
					key: [{
							required: true,
							message: '请填写种类名',
							trigger: 'blur'
						},
						{
							type: 'string',
							max: 20,
							message: '输入不得大于20个字',
							trigger: 'blur'
						}
					],
					value: [{
							required: true,
							message: '请填写编号',
							trigger: 'blur'
						},
						{
							type: 'string',
							max: 20,
							message: '输入不得大于20个字',
							trigger: 'blur'
						}
					],
					note: [{
							required: false,
							message: '请填写备注',
							trigger: 'blur'
						},
						{
							type: 'string',
							max: 50,
							message: '输入不得大于50个字',
							trigger: 'blur'
						}
					]
				},
				advancedSelect: false,
				permission: {
					isAdd: false,
					isDelete: false,
					isBatchImport: false,
					isAddCommodityType: false,
					isDeleteCommodityType: false,
					isEdit: false,
					isEditUse: false,
					isExport: false,
					isCreateCode: false
				},
				pageSizeOpts: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
				// 图片预览相关 - 简化后的变量
				previewVisible: false,
				previewImagesList: [],
				currentImageIndex: 0,
				viewCommodityStock: false,
				stockColumn: [{
						title: '规格',
						key: 'commodityPriceType',
						width: 240
					}, {
						title: '商品批次',
						key: 'batchCode',
						width: 180
					}, {
						title: '所在仓库',
						key: 'depotName',
						width: 150
					}, {
						title: '生产日期',
						key: 'productDate',
						width: 150
					}, {
						title: '保质期',
						key: 'sellbyDate',
						width: 150
					}, {
						title: '库存',
						key: 'stock',
						width: 150,
						render: (h, params) => {
							return h('span', {}, params.row.stock + params.row.commodity.unit);
						}
					},
					{
						title: '操作',
						key: 'action',
						width: 150,
						align: 'center',
						fixed: 'right',
						render: (h, params) => {
							return h('a', {
								class: ['jxyd-a'],
								style: {
									'margin-right': '5px'
								},
								attrs: {},
								on: {
									click: (e) => {
										this.deleteInventory(params.row.id);
									}
								},
							}, "删除");
						}
					}
				],
				stockData: [],
				stockModalSearchVal: '',
				tableHeight: 0,
			}
		},

		methods: {
			initTreeData() {
				let self = this;
				request.get('/api/DataDictionary/GetTreeOfDataDictionary', {
					params: {
						code: self.commodityTypePid
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取导航树数据失败：" + response.errorMsg
						});
						return;
					}
					self.treeData = response.data;
					self.initTreeNode(self.treeData);
				}).catch(function(error) {})
			},
			initTreeNode(treeData) {
				for (let i = 0; i < treeData.length; i++) {
					treeData[i].render = (h, {
						root,
						node,
						data
					}) => {
						return h('div', {
							style: {
								'display': 'flex',
								'height': '22px',
								'line-height': '22px'
							}
						}, [
							h('img', {
								style: {
									'width': '22px',
									'height': '22px'
								},
								attrs: {
									src: "/static/imgs/shangpin.png"
								}
							}),
							h('span', {
								style: {
									cursor: 'pointer',
									//backgroundColor: node.node.selected ? "rgb(255, 106, 127)" : "transparent"
								},
								attrs: {
									class: `ivu-tree-title`
								},
								on: {
									click: (e) => {
										if (!node.node.selected) {
											this.$refs.commodityTree.handleSelect(node.nodeKey);

										}
									}
								}
							}), data.title
						]);

					};
					if (treeData[i].children && treeData[i].children.length > 0) {
						this.initTreeNode(treeData[i].children);
					}
				}
			},
			clickNode() {
				let treeNode = this.$refs.commodityTree.getSelectedNodes();
				if (treeNode.length <= 0) {
					return;
				}
				if (treeNode[0].title != '商品种类') {
					this.searchItems.type = [treeNode[0].path];
				} else {
					this.searchItems.type = [];
				}
				this.initListData(1);
			},
			initListData(index) {
				let self = this;
				self.searchItems.pageIndex = index;
				request.post('/api/Commodity/GetCommodityList', self.searchItems).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取商品列表数据失败：" + response.errorMsg
						});
						return;
					}
					self.commodityData = response.data.commodity;
					self.commodityCount = response.data.commodityCount;
					self.setSelection();
				}).catch(function(error) {})
			},
			initDepotData() {
				let self = this;
				request.get('/api/Depot/GetDepotList').then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取仓库数据失败：" + response.errorMsg
						});
						return;
					}
					self.depotList = response.data;
				}).catch(function(error) {})
			},
			addCommodity() {
				this.$router.push({
					path: 'commodityfunc'
				});
			},
			editCommodity(data) {
				this.$router.push({
					path: 'commodityfunc',
					query: {
						commodityId: data.id
					}
				});
			},
			deleteCommodity(id) {
				if (this.selectedId.length <= 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '请选中要删除的商品！'
					});
					return;
				}
				var self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: "商品删除后不可恢复，是否继续操作？",
					onOk() {
						request.post('/api/Commodity/DeleteCommodity', self.selectedId).then(function(response) {

							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: response.errorMsg
								});
								return;
							}
							self.initListData(1);
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			pageChange(index) {
				this.initListData(index);
			},
			pageSizeChange(pageSize) {
				this.searchItems.pageSize = pageSize;
				this.initListData(1);
			},
			commodityTypeSubmit(type) {
				this.$refs["commodityTypeform"].validate((valid) => {
					if (valid) {
						let self = this;
						if (!self.commodityTypeFormItem.pcode) {
							self.commodityTypeFormItem.pcode = self.$refs.commodityTree.getSelectedNodes()[0]
								.value;
						}
						if (self.commodityTypeFormItem.id < 1) {
							for (var i = 0; i < self.treeData[0].children.length; i++) {
								if (self.treeData[0].children[i].title == self.commodityTypeFormItem.key) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '商品种类名已存在!'
									});
									return;
								}
							}
						}
						self.commodityTypeFormItem.value = self.commodityTypeFormItem.key;
						self.commodityTypeFormItem.note = this.commodityTypePid;
						request.post('/api/DataDictionary/AddDataDictionary', self.commodityTypeFormItem).then(
							function(response) {
								if (response.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '保存失败:' + response.errorMsg
									});
									return;
								}

								self.$Notice.success({
									title: '正确提示',
									duration: 3,
									desc: '保存成功!'
								});
								self.initTreeData();
								if (type == 1) {
									self.commodityTypeModal = false;
								} else {
									let pid = self.commodityTypeFormItem.pcode;
									self.$refs["commodityTypeform"].resetFields();
									self.commodityTypeFormItem.pcode = pid;
								}
							}).catch(function(error) {})
					}
				})
			},
			openCommodityTypeModal() {
				let treeNode = this.$refs.commodityTree.getSelectedNodes();
				if (treeNode.length <= 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '请选择要添加种类的父级！'
					});
					return;
				}
				this.commodityTypeModal = true;
				this.$refs["commodityTypeform"].resetFields();
				this.commodityTypeFormItem.pcode = '';
			},
			deleteCommodityType() {
				let treeNode = this.$refs.commodityTree.getSelectedNodes();
				if (treeNode.length <= 0 || treeNode[0].value == this.commodityTypePid) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '请选中要删除的商品种类！'
					});
					return;
				}
				if (treeNode[0].children.length > 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '当前种类下还有子种类，不可删除！'
					});
					return;
				}
				for (var i = 0; i < this.commodityData.length; i++) {
					if (treeNode[0].path.indexOf(this.commodityData[i].type) > -1) {
						this.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '当前种类下还有商品，不可删除！'
						});
						return;
					}
				}
				var self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: "商品种类删除后不可恢复，是否继续操作？",
					onOk() {
						request.post('/api/DataDictionary/DeleDataDictionary', [treeNode[0].id]).then(function(
							response) {
							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: response.errorMsg
								});
								return;
							}
							self.initTreeData();
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '删除成功!'
							});
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			editUse(item) {
				let self = this;
				let tag = '';
				if (!item.isUse) {
					tag = '启用';
				} else {
					tag = '停用';
				}
				this.$Modal.confirm({
					title: "操作警告",
					content: "是否确认" + tag + "“" + item.name + "”商品？",
					onOk() {
						request.get('/api/Commodity/EditUse', {
							params: {
								id: item.id,
								isUse: !item.isUse
							}
						}).then(function(response) {
							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: '更新失败:' + response.errorMsg
								});
								return;
							}
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '更新成功!'
							});
							item.isUse = !item.isUse;
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			batchAddCommodityBefore(file) {},
			batchAddCommoditySuccess(response, file, fileList) {
				if (response.state == 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '导入失败：' + response.errorMsg + '!'
					});
					return;
				}
				let self = this;
				request.post('/api/Commodity/BatchAddCommodity', {
					Path: response.data,
					Creator: localStorage.getItem("userId")
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "导入失败：" + response.errorMsg
						});
						return;
					}

					self.initListData(1);
				}).catch(function(error) {})
			},
			batchAddCommodityError(error, file, fileList) {
				this.$Notice.error({
					title: '错误提示',
					duration: 3,
					desc: '上传失败：' + error + '!'
				});
			},
			batchAddCommodityFormatError(file) {
				this.$Notice.error({
					title: '错误提示',
					duration: 3,
					desc: '导入失败：请选择xls、xlsx格式文件！'
				});
			},
			uploadFileSizeError(file) {
				this.$Notice.error({
					title: '错误提示',
					duration: 3,
					desc: '上传失败：不可上传超过2M大小文件！'
				});
			},
			foldSearch() {
				this.advancedSelect = false;
				this.searchItems.depotId = 0;
				this.searchItems.note = '';
			},
			initSearch() {
				this.searchItems.name = '';
				this.searchItems.code = '';
				this.searchItems.format = '';
				this.searchItems.depotId = 0;
				this.searchItems.note = '';
				this.searchItems.isUse = -1;
			},
			initPermission() {
				let self = this;
				let params = {
					funcCodes: ['Commodity.Delete', 'Commodity.BatchImport', 'Commodity.AddCommodityType',
						'Commodity.DeleteCommodityType', 'Commodity.Add', 'Commodity.Edit', 'Commodity.EditUse',
						'Commodity.Export', 'Commodity.CreateCode'
					],
					userId: parseInt(localStorage.getItem("userId"))
				};
				request.post('/api/Function/VerifyPermissions', params).then(function(response) {
					let tipTimeoutCount = localStorage.getItem("_tipTimeoutCount")
					if (tipTimeoutCount != undefined) {
						tipTimeoutCount = parseInt(tipTimeoutCount);
					}
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取权限数据失败：" + response.errorMsg
						});
						return;
					} else if (response.state == 2 && (tipTimeoutCount == undefined || tipTimeoutCount >= 1000)) {
						self.$Modal.warning({
							title: '系统到期提示',
							content: response.errorMsg,
							onOk: () => {
								localStorage.setItem("_tipTimeoutCount", 1);
							}
						});
					}
					if (tipTimeoutCount == undefined || tipTimeoutCount < 1000) {
						localStorage.setItem("_tipTimeoutCount", tipTimeoutCount == undefined ? 1 :
							tipTimeoutCount + 1)
					}
					for (var i = 0; i < response.data.length; i++) {
						switch (response.data[i].funcCode) {
							case 'Commodity.Delete':
								self.permission.isDelete = response.data[i].permission
								break;
							case 'Commodity.BatchImport':
								self.permission.isBatchImport = response.data[i].permission
								break;
							case 'Commodity.AddCommodityType':
								self.permission.isAddCommodityType = response.data[i].permission
								break;
							case 'Commodity.DeleteCommodityType':
								self.permission.isDeleteCommodityType = response.data[i].permission
								break;
							case 'Commodity.Add':
								self.permission.isAdd = response.data[i].permission
								break;
							case 'Commodity.Edit':
								self.permission.isEdit = response.data[i].permission
								break;
							case 'Commodity.EditUse':
								self.permission.isEditUse = response.data[i].permission
								break;
							case 'Commodity.Export':
								self.permission.isExport = response.data[i].permission
								break;
							case 'Commodity.CreateCode':
								self.permission.isCreateCode = response.data[i].permission
								break;
						}
					}
				}).catch(function(error) {})
			},
			handleDownLoad() {
				let self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: "是否导出列表数据？",
					onOk() {
						fetch('/api/Util/ExportCommodityListExcel', {
								method: 'POST',
								headers: new Headers({
									'Authorization': window.localStorage.getItem('token'),
									'Schema': window.localStorage.getItem('schema'),
									'WorkShop': window.localStorage.getItem('workshop'),
									'Content-Type': 'application/json;charset=UTF-8',
									'Accept': 'application/octet-stream' // 明确接受二进制流
								}),
								body: JSON.stringify(self.searchItems)
							})
							.then(res => res.blob())
							.then(data => {
								const blobUrl = window.URL.createObjectURL(data);
								self.download(blobUrl, '商品信息.xlsx');
							});
					},
					onCancel() {}
				});
			},
			download(blobUrl, name) {
				const a = document.createElement('a');
				a.download = name;
				a.href = blobUrl;
				a.click();
			},
			createCode() {
				if (this.selectedItem.length <= 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '请选中要生成条码的商品！'
					});
					return;
				}
				let selectedData = {
					name: 'commodity',
					attributes: [{
						name: 'name',
						displayName: '商品名'
					}, {
						name: 'unit',
						displayName: '计量单位'
					}, {
						name: 'format',
						displayName: '规格型号'
					}, {
						name: 'retailPrice',
						displayName: '零售价格'
					}, {
						name: 'wholesalePricePrice',
						displayName: '批发价格'
					}, {
						name: 'intoPrice',
						displayName: '采购价格'
					}, {
						name: 'note',
						displayName: '备注'
					}],
					printData: this.selectedItem
				}
				localStorage.setItem('_printData', JSON.stringify(selectedData));
				this.$router.push({
					path: 'printercodepage'
				});
			},
			printSKUCode() {
				if (this.selectedItem.length <= 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '请选中要打印条码的商品！'
					});
					return;
				}
				let selectedData = this.selectedItem.flatMap(commodity => {
					return commodity.commodityPriceTypeGroups.flatMap(group =>
						group.commodityPriceTypes
						.filter(priceType => priceType.code)
						.map(priceType => ({
							id: priceType.id,
							name: commodity.name,
							code: priceType.code,
							unit: commodity.unit,
							format: priceType.priceType,
							retailPrice: priceType.retailPrice,
							wholesalePricePrice: priceType.wholesalePricePrice,
							intoPrice: priceType.intoPrice,
							note: ''
						}))
					);
				});
				if (selectedData.length <= 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '没有可打印的单品！'
					});
					return
				}

				let printData = {
					name: 'sku',
					attributes: [{
						name: 'name',
						displayName: '单品名'
					}, {
						name: 'unit',
						displayName: '计量单位'
					}, {
						name: 'format',
						displayName: '规格型号'
					}, {
						name: 'retailPrice',
						displayName: '零售价格'
					}, {
						name: 'wholesalePricePrice',
						displayName: '批发价格'
					}, {
						name: 'intoPrice',
						displayName: '采购价格'
					}, {
						name: 'note',
						displayName: '备注'
					}],
					printData: selectedData
				}

				localStorage.setItem('_printData', JSON.stringify(printData));
				this.$router.push({
					path: 'printercodepage'
				});
			},
			batchFunc(name) {
				switch (name) {
					case 'batchDele':
						this.deleteCommodity(-1)
						break;
					case 'createCode':
						this.createCode();
						break;
					case 'printSKUCode':
						this.printSKUCode();
						break;
				}
			},
			listCheckedChange(items) {
				this.selectedItem = [];
				this.selectedId = [];
				for (var i = 0; i < items.length; i++) {
					this.selectedItem.push(items[i]);
					this.selectedId.push(items[i].id);
				}
			},
			setSelection() {
				var self = this
				this.commodityData.forEach(row => {
					if (self.selectedId.includes(row.id)) {
						row._checked = true;
					} else {
						row._checked = false;
					}
				});
			},
			/**
			 * 预览SKU图片 - 简化版本，使用子组件
			 */
			previewSkuImages(images) {
				if (!images || images.length === 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "暂无图片"
					});
					return;
				}

				this.previewImagesList = images;
				this.currentImageIndex = 0;
				this.previewVisible = true;
			},

			/**
			 * 图片切换事件
			 */
			onPreviewImageChange(index, image) {
				this.currentImageIndex = index;
			},
			initStockData(id) {
				let self = this
				request.post('api/Commodity/GetCommodityStockList', {
					commodityId: id,
					searchVal: self.stockModalSearchVal
				}).then(function(result) {
					if (result.state != 1) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取库存信息失败：" + result.errorMsg
						});
						return
					}
					self.stockData = result.data;
				}).catch(err => {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "获取库存信息失败"
					});
				})
			},
			deleteInventory(id) {
				let self = this
				this.$Modal.confirm({
					title: "操作警告",
					content: "删除后不可恢复，是否继续操作？",
					onOk() {
						request.get('api/Commodity/DeleteCommodityStock', {
							params: {
								commodityId: self.commodityCurrentIndex,
								inventoryId: id,
							}
						}).then(function(result) {
							if (result.state != 1) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: "删除失败:" + result.errorMsg
								});
								return
							}
							self.initItemData();
						}).catch(err => {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "删除失败:" + result.errorMsg
							});
						})
					},
					onCancel() {}
				});
			}
		},
		watch: {},
		created: function() {
			this.$nextTick(() => {
				let contentElement = document.querySelector(".main-content");
				this.tableHeight = contentElement ? contentElement.offsetHeight - 110 : 700;
			})
			this.initPermission();
			this.initTreeData();
			this.initListData(1);
			this.initDepotData();
		}
	}
</script>

<style scoped>
	.layout {
		background: #fff;
		border-radius: 8px;
		height: 100%;
	}

	.layout-title {
		overflow: hidden;
		padding: 10px;
		font-size: 16px;
		border-bottom: 1px solid #e8eaec;
	}

	#box-search {
		padding-top: 20px;
	}

	.layout-title-left {
		float: left;
		height: 32px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.layout-title-right {
		float: right;
	}

	#page-box {
		margin-top: 20px;
		text-align: center;
	}

	.demo-split-pane {
		height: 100%;
		padding: 0px 20px 10px 20px;
		overflow-y: auto;
	}

	/*#head-img-ava {
        cursor: pointer;
        margin-left: 10px;
        margin-bottom: 20px;
        border: 1px solid #e8eaec;
    }

        #head-img-ava:hover {
            transform: scale(1.1);
        }*/

	.icon-btn {
		margin: 10px 0px 0px 10px;
		cursor: pointer
	}

	.icon-btn:hover {
		transform: scale(1.1);
	}

	.dropdown-item {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.modal-header {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
</style>